import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

// material
import { styled } from '@material-ui/core/styles';
import { Box, Link, AppBar, Toolbar, Container, collapseClasses } from '@material-ui/core';
// hooks
import useOffSetTop from '../../hooks/useOffSetTop';
import { MHidden } from '../../components/@material-extend';
//
import MenuDesktop from './MenuDesktop';
import MenuMobile from './MenuMobile';
import navConfig from './MenuConfig';
import { varBounceInDown } from '../../components/animate';
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 88;

const NavBar = styled(AppBar)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  borderRadius: '50%',
  margin: '20px',
  width: 'calc(100% - 40px)',
  boxShadow: 'none',
}));

const NavContainer = styled(Container)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 20px'
});

const Logo = styled(Box)({
  display: 'flex',
  alignItems: 'center'
});

const LogoCircle = styled(Box)({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundColor: '#000',
  marginRight: '10px'
});

const NavLink = styled(Link)(({ theme }) => ({
  color: '#FFFFFF',
  textDecoration: 'none',
  margin: '0 20px',
  fontSize: '14px',
  '&:hover': {
    color: '#000'
  }
}));

const SignInButton = styled(Box)({
  backgroundColor: '#000',
  color: '#000B18',
  padding: '8px 20px',
  borderRadius: '15px',
  fontWeight: 'bold',
  cursor: 'pointer'
});

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: APP_BAR_MOBILE,
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  borderRadius: 30,
  backdropFilter: 'blur(6px)',
  backgroundColor: 'rgba(255, 255, 255, 0.1)', // Glass effect
  [theme.breakpoints.up('md')]: {
    height: APP_BAR_DESKTOP
  }
}));

const ToolbarShadowStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 20,
  zIndex: -1,
  margin: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  width: `calc(100% - 48px)`,

  boxShadow: theme.customShadows.z8,
}));

// ----------------------------------------------------------------------

export default function MainNavbar() {
  const isOffset = useOffSetTop(100);
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <AppBar sx={{ boxShadow: 0, bgcolor: 'transparent', marginTop: '5px',}}>
      <ToolbarStyle
        disableGutters
        sx={{
          ...(isOffset && {
            height: { md: APP_BAR_DESKTOP - 12 },
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          })
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            overflow: 'hidden'
          }}
        >
          <Link component={RouterLink} to="/" underline="none">
            <Box sx={{ width: '250px', height: '50px', mx: 'auto', my: 1, display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 200, pr: { xs: 10, sm: 5, md: 5 }, pl: 0, py: 5 }}>
                <motion.img variants={varBounceInDown} src="/static/logo.png" style={{ objectFit: 'contain' }} />
              </Box>
            </Box>
          </Link>

          <Box sx={{ flexGrow: 1 }} />

          <MHidden width="mdDown">
            <MenuDesktop isOffset={isOffset} isHome={isHome} navConfig={navConfig} />
          </MHidden>

          <MHidden width="mdUp">
            <MenuMobile isOffset={isOffset} isHome={isHome} navConfig={navConfig} />
          </MHidden>
        </Container>
      </ToolbarStyle>

      {/* {isOffset && <ToolbarStyle />} */}
    </AppBar>
  );
}
